/* eslint-disable react/jsx-indent-props */
import React from "react";
import "./styles.scss";

export const currencyFormatter = new Intl.NumberFormat("en-GB", {
  currency: "GBP",
  style: "currency",
  maximumFractionDigits: 0,
  minimumFractionDigits: 0,
});

export const formatNumberWithoutDecimals = (num: number) => currencyFormatter.format(Math.ceil(num));
export interface IProps {
  stampDutyResult: number;
}

export const StampDutyCalculatorResults: React.FunctionComponent<IProps> = ({
  stampDutyResult,
}) => (
  <div className="stamp-duty-calculator-results stamp-duty-calculator-results-single-result">
    <div className="stamp-duty-calculator-results__content">
      <h2
          className="stamp-duty-calculator-results__single-result-heading"
          aria-level={2}
      >
        Stamp duty to pay
      </h2>
      <div className="stamp-duty-calculator-results__single-result-total" data-testid="stamp-duty-calculator-0">
        {formatNumberWithoutDecimals(stampDutyResult)}
      </div>
    </div>
  </div>
);
